const lugaresPrestacion = [
  { id: "DOMICILIO", nombre: "Domicilio particular" },
  { id: "ESPACIO", nombre: "Espacio colectivo" },
];

export default lugaresPrestacion;
